import { Check, Circle } from "lucide-react";
import { getPasswordRules } from "@shared/password-policy";
import { cn } from "@/lib/utils";

interface PasswordRequirementsProps {
  value: string;
  className?: string;
  testIdPrefix?: string;
}

export function PasswordRequirements({ value, className, testIdPrefix = "password-rule" }: PasswordRequirementsProps) {
  const rules = getPasswordRules();
  return (
    <ul className={cn("space-y-1", className)} data-testid="list-password-requirements">
      {rules.map((rule) => {
        const ok = rule.test(value);
        return (
          <li
            key={rule.key}
            className={cn(
              "flex items-center gap-2 text-xs transition-colors",
              ok ? "text-emerald-600 dark:text-emerald-400" : "text-muted-foreground",
            )}
            data-testid={`${testIdPrefix}-${rule.key}`}
            data-state={ok ? "met" : "unmet"}
          >
            {ok ? (
              <Check className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
            ) : (
              <Circle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
            )}
            <span>{rule.label}</span>
            <span className="sr-only">{ok ? " (met)" : " (not met)"}</span>
          </li>
        );
      })}
    </ul>
  );
}
